import React, { useState } from 'react';
import plusSvg from '../../assets/images/faqs/svg/plus.svg'
import minusSvg from '../../assets/images/faqs/svg/minus.svg'
import faqData from './data-renderer/FaqsData';

const FAQItem = ({ question, answer, isOpen, toggle, isList, list }) => (
    <div className="border-b border-black border-opacity-20 py-4">
        <button
            className="flex justify-between lg:px-8 items-center w-full text-left"
            onClick={toggle}
        >
            <span className={`${isOpen ? 'text-xl leading-7 lg:text-2xl font-medium' : 'text-base font-normal leading-[26px] opacity-70'} pt-8 pb-[26px] max-w-[291px] lg:max-w-full`}>
                {question}
            </span>
            {isOpen ? (
                <img src={minusSvg} alt="minus" className='lg:h-8 lg:w-8 h-6 w-6' />
            ) : (
                <img src={plusSvg} alt="plus" className='lg:h-8 lg:w-8 h-6 w-6' />
            )}
        </button>
        {isOpen && (
            <div className="text-base font-normal leading-[26px] lg:px-8 opacity-70 pb-6 lg:pb-8">
                <p>{answer}</p>
                {isList && (
                    <ol className="list-[lower-alpha] pl-5 mt-2">
                        {list.map((item, index) => (
                            <li key={index} className="mb-2">{item.trim()}</li>
                        ))}
                    </ol>
                )}
            </div>
        )}
    </div>
);

const FAQsSection = () => {
    const [openItem, setOpenItem] = useState();

    return (
        <div className="px-[30px] lg:px-[120px] pb-20 lg:pb-[120px]">
            <h1 className="text-[40px] leading-[54px] font-semibold text-center mb-6 lg:mb-10 text-[#27506E]">FAQs</h1>
            {faqData.map((item, index) => (
                <FAQItem
                    key={index}
                    question={item.question}
                    answer={item.answer}
                    isOpen={index === openItem}
                    toggle={() => setOpenItem(index === openItem ? -1 : index)}
                    isList={item.isList}
                    list={item.list}
                />
            ))}
        </div>
    );
};

export default FAQsSection;